import { usePage } from "@inertiajs/react"
import type { SharedProps } from "@/types/inertia"

export function useAuth() {
  const { props } = usePage<SharedProps>()
  const user = props.current_user

  return {
    user,
    isLoggedIn: user !== null,
    isAdmin: user?.admin ?? false,
  }
}
